// Booking form constants and configuration

export const projects = [
  { name: "RRL Nature Crust" },
  { name: "RRL Palacio" },
  { name: "RRL Nature Woods" },
  { name: "RRL Towers" },
  { name: "RRL Complex" },
];

export const wings = ["Wing 1", "Wing 2", "Wing 3", "Wing 4"];

export const bhkTypes = ["1BHK", "2BHK", "3BHK"];

export const professions = [
  "Salaried", "Self-Employed", "Business Owner", "Professional",
  "Government Employee", "Retired", "Other"
];

export const initialFormData = {
  // Primary Applicant
  name: "", phone: "", email: "", father_name: "", date_of_birth: "",
  gender: "male", pan_number: "", aadhar_number: "", address: "",
  company: "", designation: "", profession: "", nationality: "Indian",
  // Co-Applicant
  co_applicant_name: "", co_applicant_father_name: "", co_applicant_gender: "male",
  co_applicant_phone: "",
  co_applicant_email: "", co_applicant_pan: "", co_applicant_aadhar: "",
  co_applicant_address: "", co_applicant_date_of_birth: "",
  co_applicant_profession: "", co_applicant_nationality: "Indian",
  // Property
  project: "", tower: "", unit_number: "", bhk_type: "", floor: "",
  saleable_area: "", rate_per_sqft: "6600",
  parking: "1", additional_parking: "1", club_house_charges: "200000", additional_charges: "0",
  // Payment
  booking_amount: "", transaction_details: "", transaction_date: "", transaction_bank: "",
  // Finance
  finance_type: "self", finance_bank: "",
  // Remarks
  remarks: "",
};

export const initialUploadedFiles = {
  pan_card: null, aadhar_card: null, passport: null,
  co_pan_card: null, co_aadhar_card: null, co_passport: null,
};

export const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency", currency: "INR", maximumFractionDigits: 0,
  }).format(amount || 0);
};

export const calculatePrice = (formData) => {
  const saleableArea = parseFloat(formData.saleable_area) || 0;
  const ratePerSqft = parseFloat(formData.rate_per_sqft) || 0;
  const amenitiesCharges = parseFloat(formData.club_house_charges) || 200000;
  // Car Parking is a FIXED ₹2,00,000 line item — not multiplied by slot count.
  const parkingCharges = 200000;
  const additionalCharges = parseFloat(formData.additional_charges) || 0;

  const basePrice = saleableArea * ratePerSqft;
  const subtotal = basePrice + amenitiesCharges + parkingCharges + additionalCharges;
  const labourCess = subtotal * 0.007;
  const gst = subtotal * 0.05;
  const total = subtotal + labourCess + gst;

  return {
    basePrice,
    effectiveRate: ratePerSqft,
    floorRiseTotal: 0,
    floorRiseCost: 0,
    clubHouse: amenitiesCharges,
    amenities: amenitiesCharges,
    additionalParking: 1,
    parkingCharges,
    additionalCharges,
    subtotal, labourCess, gst, total,
  };
};
